import React from 'react';
import './privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-content">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: March 2024</p>

        <section>
          <h2>1. Information We Collect</h2>
          <h3>Personal Information</h3>
          <ul>
            <li>Email address</li>
            <li>Name (if provided)</li>
            <li>Profile picture (if provided through social login)</li>
            <li>Payment information (processed securely by Yoco)</li>
          </ul>

          <h3>Usage Data</h3>
          <ul>
            <li>Conversation inputs and responses</li>
            <li>Usage patterns and preferences</li>
            <li>Device and browser information</li>
          </ul>
        </section>

        <section>
          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>To provide and maintain our service</li>
            <li>To process your payments</li>
            <li>To improve our AI responses</li>
            <li>To communicate with you about your subscription</li>
            <li>To detect and prevent abuse</li>
          </ul>
        </section>

        <section>
          <h2>3. Data Storage and Security</h2>
          <p>We use industry-standard security measures to protect your data:</p>
          <ul>
            <li>All data is encrypted in transit and at rest</li>
            <li>We use secure cloud infrastructure (Firebase)</li>
            <li>Regular security audits and updates</li>
            <li>Limited employee access to personal data</li>
          </ul>
        </section>

        <section>
          <h2>4. Data Sharing</h2>
          <p>We do not sell your personal data. We may share data with:</p>
          <ul>
            <li>Payment processors (Yoco)</li>
            <li>Cloud service providers (Firebase)</li>
            <li>Analytics services (anonymized data only)</li>
          </ul>
        </section>

        <section>
          <h2>5. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access your personal data</li>
            <li>Correct inaccurate data</li>
            <li>Request deletion of your data</li>
            <li>Export your data</li>
            <li>Opt-out of non-essential data collection</li>
          </ul>
        </section>

        <section>
          <h2>6. Cookies and Tracking</h2>
          <p>We use essential cookies for:</p>
          <ul>
            <li>Authentication</li>
            <li>Security</li>
            <li>User preferences</li>
          </ul>
        </section>

        <section>
          <h2>7. Contact Us</h2>
          <p>For privacy-related questions or concerns, contact us at:</p>
          <p>privacy@rizzologygpt.com</p>
        </section>
      </div>
    </div>
  );
};

export default Privacy; 